import Types from "./types";

export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    fetchStart = (payload) => this.dispatch({ type: Types.FETCH_START, payload });

    fetchOneStart = (payload) => this.dispatch({ type: Types.FETCH_ONE_START, payload });

    updateStart = (payload) => this.dispatch({ type: Types.UPDATE_START, payload });

    createStart = (payload) => this.dispatch({ type: Types.CREATE_START, payload });

    deleteStart = (payload) => this.dispatch({ type: Types.DELETE_START, payload });

    resetDetail = () => this.dispatch({ type: Types.RESET_DETAIL, payload: {} });

    resetError = () => this.dispatch({ type: Types.RESET_ERROR, payload: {} });
}